import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "@/components/SEO";
import Navigation from "@/components/Navigation";
import HeroCarousel from "@/components/HeroCarousel";
import SanskritQuote from "@/components/SanskritQuote";
import YogaNidraOverview from "@/components/YogaNidraOverview";
import BrainWaveActivity from "@/components/BrainWaveActivity";
import AboutSection from "@/components/AboutSection";
import AppFeatures from "@/components/AppFeatures";
import BlogSection from "@/components/BlogSection";
import CTABanner from "@/components/CTABanner";
import Testimonials from "@/components/Testimonials";
import DownloadApp from "@/components/DownloadApp";
import Footer from "@/components/Footer";
import {
  webApplicationSchema,
  websiteSchema,
  organizationSchema,
} from "@/lib/seoSchemas";

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a section to scroll to from navigation state
    const state = location.state as { scrollTo?: string };
    if (state?.scrollTo) {
      // Small delay to ensure all components are rendered
      setTimeout(() => {
        const element = document.getElementById(state.scrollTo);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);

  const homeSchema = {
    "@context": "https://schema.org",
    "@graph": [webApplicationSchema, websiteSchema, organizationSchema],
  };

  return (
    <div className="min-h-screen bg-cloud-white">
      <SEO
        title="Cittasya® - Awaken Deep rest with Yoga Nidra| Deep Relaxation & Stress Relief"
        description="Transform your life with Cittasya® Yoga Nidra app. Experience guided deep relaxation practice, stress relief, better sleep, pain relief, and enhanced self-awareness through ancient Yoga Nidra techniques for mental wellness and inner peace."
        url="https://cittasya.com/"
        image="https://cittasya.com/hero-1.png"
        schema={homeSchema}
      />
      <Navigation />
      <HeroCarousel />
      <SanskritQuote />
      <YogaNidraOverview />
      <BrainWaveActivity />

      <AboutSection />
      <AppFeatures />
      <BlogSection />
      {/* <CTABanner /> */}
      <Testimonials />

      <DownloadApp />
      <Footer />
    </div>
  );
};

export default Index;
